import React from "react";
import "./TermsAndConditon.scss";
import TAConditionCTA from "./TAConditionCTA";
import { useTranslation } from "react-i18next";

const TermsAndConditionFirst = ({ isPreview, handlePrevious }) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className={`TermsWrapper ${
          isPreview ? "applicantDetailsCard previewColor" : ""
        }`}
      >
        {isPreview ? (
          <h3 className="titlePersonalHD marginBottom16">
            {t("termsAndConditions.title")}
          </h3>
        ) : (
          <div className="titleTerms">{t("termsAndConditions.title")}</div>
        )}

        {t("termsAndConditions.sections", { returnObjects: true }).map((section, idx) => (
          <React.Fragment key={idx}>
            <ol className="ListNumber">
              <li>
                <b className="liB">{section.heading}</b>{" "}
                {section.description}
                {section.list && (
                  <ul>
                    {section.list.map((point, pIdx) => (
                      <li key={pIdx}>{point}</li>
                    ))}
                  </ul>
                )}
              </li>
            </ol>

            {section.table && (
              <div className="tbResponsive">
                <table>
                  <thead>
                    <tr>
                      {section.table.headers.map((header, hIdx) => (
                        <th key={hIdx}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {section.table.rows.map((row, rIdx) => (
                      <tr key={rIdx}>
                        {row.map((cell, cIdx) => (
                          <td key={cIdx}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {section.subpoints?.length > 0 && (
              <div className="subpointsWrapper">
                {section.subpoints.map((subpoint, spIdx) => (
                  <p key={subpoint} className="subpoint">
                    <span className="subpointNumber">
                      {idx + 1}.{spIdx + 1}
                    </span>{" "}
                    {subpoint}
                  </p>
                ))}
              </div>
            )}

            {section.notes && (
              <ol className="ListNumber">
                {section.notes.map((note, nIdx) => (
                  <li key={nIdx}>{note}</li>
                ))}
              </ol>
            )}
          </React.Fragment>
        ))}
        </div>

        <div className="applicantDetailsCard">
        <div className="declarationWrap">
          <ol className="ListNumber">
            <li>
              <b className="title">
                {t("termsAndConditions.declaration.title")}
              </b>
            </li>
          </ol>

          <p>{t("termsAndConditions.declaration.intro")}</p>

           {t("termsAndConditions.declaration.points", { returnObjects: true }).map((point, idx) => (
            <p key={idx}>
              {idx + 1}. {point}
            </p>
          ))}

          <p>{t("termsAndConditions.declaration.finalNote")}</p>
        </div>
        {!isPreview ? <TAConditionCTA handlePrevious={handlePrevious} /> : null}
      </div>
    </>
  );
};

export default TermsAndConditionFirst;
